import type { UploadRow } from '@/models/upload';
import { useBrowserUploadProgress } from '@/features/uploads/utils/browserUploads';
import UploadStatusBadge from './UploadStatusBadge';
import badgeStyles from './UploadStatusBadge/UploadStatusBadge.module.css';

/**
 * The Status cell: `Uploading · x/N` while this tab is still sending the
 * upload's files, then the stage the server reports.
 */
export default function UploadStatusCell({ upload }: { upload: UploadRow }) {
  const sending = useBrowserUploadProgress(upload.uuid);
  if (sending) {
    return (
      <span className={badgeStyles.badge} data-variant="processing">
        Uploading · {sending.filesSent}/{sending.filesTotal}
      </span>
    );
  }
  return <UploadStatusBadge upload={upload} />;
}
